import styled from 'styled-components';

const CourseBox = styled.div`
  margin-bottom: 48px;
  border: 1px solid rgb(230, 230, 230);
  padding: 15px;
`;

export default CourseBox;
